import React, { useEffect, useState } from 'react';
import './SubscriptionSuccessPopup.css';

interface SubscriptionSuccessPopupProps {
    isOpen: boolean;
    onClose: () => void;
}

const SubscriptionSuccessPopup: React.FC<SubscriptionSuccessPopupProps> = ({ isOpen, onClose }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (isOpen) {
            // Trigger animation after mount
            setTimeout(() => setIsVisible(true), 50);
        }
    }, [isOpen]);

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(() => {
            onClose();
        }, 300); // Wait for animation to complete
    };

    if (!isOpen) return null;

    return (
        <div className={`subs-popup-overlay ${isVisible ? 'visible' : ''}`} onClick={handleClose}>
            <div
                className={`subs-popup ${isVisible ? 'visible' : ''}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="subs-popup-icon">
                    <i className="fas fa-check-circle"></i>
                </div>

                <div className="subs-popup-content">
                    <h2 className="subs-title">Ödeme Başarılı! 🎉</h2>
                    <p className="subs-message">
                        Abonelik süreniz başarıyla uzatılmıştır.
                        <br />
                        <br />
                        <span className="info-text">
                            <i className="fas fa-info-circle"></i> Değişiklikleri görmek için sisteme tekrar giriş yapmalısınız.
                        </span>
                    </p>
                </div>

                <button className="subs-popup-btn" onClick={handleClose}>
                    <i className="fas fa-arrow-right"></i>
                    Devam Et
                </button>
            </div>
        </div>
    );
};

export default SubscriptionSuccessPopup;
